import {OptionCardComponent} from "./option-card.component";
import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";


@NgModule({
  declarations: [
    OptionCardComponent
  ],
  exports: [
    OptionCardComponent
  ],
  imports: [
    CommonModule
  ],
})
export class Home365OptionCardModule {}
